import { render, staticRenderFns } from "./SidebarFields.vue?vue&type=template&id=b6ea0dda&scoped=true&"
import script from "./SidebarFields.vue?vue&type=script&lang=ts&"
export * from "./SidebarFields.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarFields.vue?vue&type=style&index=0&id=b6ea0dda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ea0dda",
  null
  
)

export default component.exports